export default __webpack_public_path__ + "static/20250131-5f87429bad1ca226790b9fdcd2104fa3.png";